import { makeStyles } from '@material-ui/core/styles';

import { COLORS, VARIATION_DETAILS_PANEL_WIDTH } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: VARIATION_DETAILS_PANEL_WIDTH,
      height: '100%',
      overflowY: 'auto',
      backgroundColor: COLORS.gray.gray90,
      borderLeft: theme.shape.border,

      '&$gated': {
        padding: theme.spacing(3, 0, 7.5, 0),
      },
    },
    overlay: {
      position: 'fixed',
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: COLORS.neutral.darkGray,
      opacity: 0.7,
    },
    gated: {},

    buttonCollapse: {
      padding: 0,

      '& svg': {
        fontSize: theme.typography.pxToRem(24),
        color: COLORS.gray.gray30,
      },
    },
    textDetails: {
      paddingBottom: 0,
    },

    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(2, 2.25, 2, 3),
      borderBottom: theme.shape.borderGray70,
      backgroundColor: 'white',
    },
    variationFormat: {
      backgroundColor: 'white',
    },

    headerTitle: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      color: COLORS.neutral.secondary,
      fontWeight: theme.typography.fontWeightSemiBold,
    },
  }),
  { name: 'VariationDetails' }
);
